<template>
  <el-table v-loading="loading" :data="data">
    <el-table-column label="STT" type="index" width="50"></el-table-column>
    <el-table-column label="Tên người dùng" prop="name">
      <template slot-scope="scope">
        <span>{{ scope.row.name }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Email" prop="email">
      <template slot-scope="scope">
        <span>{{ scope.row.email }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Số điện thoại" prop="phone">
      <template slot-scope="scope">
        <span>{{ scope.row.phone }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Chức vụ" prop="position">
      <template slot-scope="scope">
        <span>{{ scope.row.position }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Đơn vị công tác" prop="workplace">
      <template slot-scope="scope">
        <span>{{ scope.row.workplace }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Nội dung yêu cầu" prop="requirements">
      <template slot-scope="scope">
        <span>{{ scope.row.requirements }}</span>
      </template>
    </el-table-column>
    <el-table-column label="Ngày đăng ký" prop="registered_at">
      <template slot-scope="scope">
        <span>{{ scope.row.registered_at }}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="Thao tác"
      width="150"
      align="center"
      fixed="right"
    >
      <template slot-scope="scope">
        <el-tooltip content="Xóa" placement="top">
          <el-button
            icon="el-icon-delete"
            circle
            type="danger"
            size="small"
            @click="handleDelete(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { deleteUserRegisterForm } from '@/services/register-form'

export default {
  name: 'ListSupport',
  props: {
    data: Array,
    loading: Boolean
  },
  computed: {
    ...mapGetters(['constant']),
    locales() {
      return this.constant.constants.locales
    }
  },
  methods: {
    handleDelete(row) {
      this.$confirm('Bạn có chắc chắn muốn xóa không?', 'Xác nhận', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Đóng',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteUserRegisterForm({ id: row.id })
          .then(() => {
            this.$notify.success({
              title: 'Thành công',
              message: `Xóa yêu cầu thành công`
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loading = false
            this.$notify.error({
              title: 'Thông báo',
              message: 'Không thể xóa!'
            })
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
